export default __webpack_public_path__ + "static/media/92.b16f2874.png";